export default __webpack_public_path__ + "static/media/about.a8c17a64.png";